import { useContext } from 'react';

import { UserContext } from '~/modules/auth/contexts/UserContext';

const useUser = () => useContext(UserContext);

export { useUser };
